import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { Box, Flex, NumberInput, Button, Tooltip } from '@mantine/core'
import React from 'react'

import { useTranslation } from '@flecto/translations'

import { Icon } from '../Icon/Icon'

export interface NumberInputWithTooltipProps {
  value: number
  updateValue: (quantity: number) => void
  maxValue?: number
  isInfinite?: boolean
  hasPickedUpQuantity?: boolean
  remainingValue?: number
  tooltipKey?: string
  reservedQuantity: number
  isUnavailable?: boolean
}

export const NumberInputWithTooltip: React.FC<NumberInputWithTooltipProps> = ({
  value,
  updateValue,
  maxValue = Infinity,
  isInfinite = true,
  hasPickedUpQuantity = false,
  remainingValue = 0,
  tooltipKey = 'tooltip_picked_up_quantity',
  reservedQuantity,
  isUnavailable = false,
}) => {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_items' })

  const disableDecreaseButton =
    value !== undefined && value <= (reservedQuantity ?? 0)

  const canDecreaseQuantity =
    value <= 1 ||
    (!isInfinite && hasPickedUpQuantity && !remainingValue) ||
    disableDecreaseButton

  return (
    <Box pos='relative' display='inline-block' w='100%'>
      <NumberInput
        min={1}
        step={1}
        disabled={!isInfinite && hasPickedUpQuantity && !remainingValue}
        max={maxValue}
        value={value}
        onChange={(value) => updateValue(Number(value))}
        hideControls
      />

      <Flex
        pos='absolute'
        top='1px'
        right='1px'
        bottom='1px'
        w='27px'
        direction='column'
        style={{
          borderRadius: '0 4px 4px 0',
          overflow: 'hidden',
        }}
      >
        <Button
          type='button'
          variant='default'
          onClick={() => updateValue(value + 1)}
          disabled={isUnavailable}
          w='20px'
          h='20px'
          ml='-4px'
          align-items='center'
          lh='1'
          display='flex'
          bg='transparent'
          bd='none'
          style={{ justifyContent: 'center', borderBottom: 'none' }}
        >
          <Icon icon={faChevronUp} size='xs' />
        </Button>

        <Tooltip label={t(tooltipKey)} disabled={!disableDecreaseButton}>
          <Button
            type='button'
            onClick={() => {
              if (!canDecreaseQuantity) {
                updateValue(value - 1)
              }
            }}
            disabled={canDecreaseQuantity}
            variant='default'
            w='20px'
            h='20px'
            ml='-4px'
            align-items='center'
            lh='1'
            display='flex'
            bg='transparent'
            bd='none'
            style={{
              justifyContent: 'center',
              cursor: canDecreaseQuantity ? 'not-allowed' : 'pointer',
              borderBottom: 'none',
            }}
          >
            <Icon icon={faChevronDown} size='xs' />
          </Button>
        </Tooltip>
      </Flex>
    </Box>
  )
}
